export default __webpack_public_path__ + "static/media/TeamAvatar.7db9d795.svg";